// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-columns-wrapper">
        
        {/* Columna 1: Info e Identidad */}
        <div className="footer-brand-column">
          <img src="/images/logox2.png" alt="INNOVATESPORT" className="footer-brand-logo" />
          <p className="brand-legal-desc">
            Soluciones integrales para eventos deportivos. Tecnología, experiencia y pasión por el deporte.
          </p>
          <div className="footer-social-media-row">
            <a href="https://facebook.com/inovatesport" target="_blank" rel="noopener noreferrer" className="sm-link">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://instagram.com/inovatesport" target="_blank" rel="noopener noreferrer" className="sm-link">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://youtube.com/inovatesport" target="_blank" rel="noopener noreferrer" className="sm-link">
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>

        {/* Columna 2: Participantes */}
        <div className="footer-links-group-column">
          <h4 className="group-column-title">PARTICIPANTES</h4>
          <ul className="group-links-list">
            <li><Link to="/eventos" className="f-item-anchor">Eventos</Link></li>
            <li><Link to="/resultados" className="f-item-anchor">Resultados</Link></li>
            <li><Link to="/calendario" className="f-item-anchor">Calendario</Link></li>
            <li><Link to="/faqs" className="f-item-anchor">Preguntas frecuentes</Link></li>
          </ul>
        </div>

        {/* Columna 3: Organizadores */}
        <div className="footer-links-group-column">
          <h4 className="group-column-title">ORGANIZADORES</h4>
          <ul className="group-links-list">
            <li><Link to="/Inscripciones" className="f-item-anchor">Plataforma de inscripciones</Link></li>
            <li><Link to="/Cronometraje" className="f-item-anchor">Cronometraje</Link></li>
            <li><Link to="/servicios" className="f-item-anchor">Servicios</Link></li>
            <li><Link to="/cotizacion" className="f-item-anchor">Cotización</Link></li>
          </ul>
        </div>

        {/* Columna 4: Empresa */}
        <div className="footer-links-group-column">
          <h4 className="group-column-title">EMPRESA</h4>
          <ul className="group-links-list">
            <li><Link to="/about" className="f-item-anchor">Nosotros</Link></li>
            <li><Link to="/blog" className="f-item-anchor">Blog</Link></li>
            <li><Link to="/work-with-us" className="f-item-anchor">Trabajá con nosotros</Link></li>
            <li><Link to="/contacto" className="f-item-anchor">Contacto</Link></li>
          </ul>
        </div>

        {/* Columna 5: Contacto directo */}
        <div className="footer-links-group-column">
          <h4 className="group-column-title">CONTACTO</h4>
          <ul className="group-links-list-static">
            <li className="static-info-row">info@inovatesport.com</li>
            <li className="static-info-row">Bolivia</li>
          </ul>
        </div>

      </div>

      {/* Barra de cierre inferior con Copyright */}
      <div className="footer-bottom-credits">
        <div className="credits-inner-container">
          <p className="copyright-notice-text">
            © 2024 InnovateSport. Todos los derechos reservados.
          </p>
          <div className="legal-bottom-anchors">
            <Link to="/privacy" className="bottom-legal-link">Términos y condiciones</Link>
            <span className="divider-bar">|</span>
            <Link to="/terms" className="bottom-legal-link">Política de privacidad</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;